<template>
    <div class="author-pseudonymes">
        <ul v-if="authors.length" class="author-pseudonymes__list">
            <li
                v-for="(author, index) in authors"
                :key="author.id"
                class="author-pseudonymes__item"
            >
                {{ author.first_name }} {{ author.last_name }}
                <button
                    type="button"
                    class="author-pseudonymes__edit-button"
                    @click="openEdit(index)"
                >
                    {{ $t('misc.edit') }}
                </button>
            </li>
        </ul>
        <button type="button" class="author-pseudonymes__add-button" @click="openNew">
            {{ $t('pseudonymPicker.add') }}
        </button>
        <portal to="modals">
            <Modal
                v-if="showModal"
                name="pseudonym-editor"
                class="pseudonym-editor author-pseudonymes__modal"
                :title="modalTitle"
                @closed="showModal = false"
            >
                <template #content>
                    <form ref="form" class="pseudonym-editor__form" @submit.prevent="onSubmit">
                        <Spinner v-if="loading" />
                        <PhotoInput
                            class="pseudonym-editor__photo"
                            :photo="author.photo"
                            name="photo"
                            @selected="onPictureSelected"
                            @deleted="onPictureDeleted"
                        />
                        <div class="form-group form-group--flat">
                            <div
                                v-t="$t('misc.firstName')"
                                class="form-group__label"
                                style="width: 100px"
                            ></div>
                            <FormInput
                                v-model="author.first_name"
                                type="text"
                                name="first_name"
                                :placeholder="$t('misc.firstName')"
                                required
                            />
                        </div>
                        <div class="form-group form-group--flat">
                            <div
                                v-t="$t('misc.lastName')"
                                class="form-group__label"
                                style="width: 100px"
                            ></div>
                            <FormInput
                                v-model="author.last_name"
                                type="text"
                                name="last_name"
                                :placeholder="$t('misc.lastName')"
                                required
                            />
                        </div>
                        <!-- <div class="form-group form-group--flat">
                            <div
                                v-t="$t('misc.patronymic')"
                                class="form-group__label"
                                style="width: 100px"
                            ></div>
                            <FormInput
                                v-model="author.patronymic"
                                type="text"
                                name="patronymic"
                                :placeholder="$t('misc.patronymic')"
                                required
                            />
                        </div> -->
                        <div class="form-group form-group--flat">
                            <div
                                v-t="$t('pseudonymPicker.description')"
                                class="form-group__label"
                                style="width: 100px"
                            ></div>
                            <textarea
                                v-model="author.description"
                                name="description"
                                class="form-group__textarea"
                                :placeholder="$t('pseudonymPicker.description')"
                            ></textarea>
                        </div>
                        <button type="submit" class="button button--big button--centered">
                            {{ $t('misc.save') }}
                        </button>
                        <ErrorList :error="error" />
                    </form>
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { FormInput, PhotoInput, ErrorList } from '@speechki-frontend/shared/ui/forms';
import { addAuthors, updateAuthors } from '../../api';

import { mapState, mapActions } from 'vuex';

export default {
    name: 'AuthorPseudonymes',
    components: {
        Modal,
        FormInput,
        PhotoInput,
        ErrorList,
    },
    data() {
        return {
            loading: false,
            error: null,
            author: {
                id: undefined,
                first_name: '',
                last_name: '',
                patronymic: '',
                photo: undefined,
                description: '',
            },
            showModal: false,
        };
    },
    computed: {
        ...mapState({
            authors: (state) => state.auth.userAuthors,
        }),
        modalTitle() {
            if (this.author.id) return this.$t('pseudonymPicker.edit');

            return this.$t('pseudonymPicker.title');
        },
    },
    methods: {
        ...mapActions(['fetchUserAuthors']),
        openEdit(index) {
            this.author = {
                ...this.authors[index],
            };
            this.showModal = true;
        },
        openNew() {
            this.author = {
                id: undefined,
                first_name: '',
                last_name: '',
                patronymic: '',
                photo: undefined,
                description: '',
            };

            this.showModal = true;
        },
        onPictureDeleted() {
            this.author.photo = '';
        },
        onPictureSelected(file) {
            this.author.photo = file;
        },
        async onSubmit() {
            try {
                this.loading = true;
                this.error = null;
                const data = new FormData(this.$refs.form);

                if (typeof this.author.photo === 'string' && this.author.photo !== '') {
                    data.delete('photo');
                }

                if (this.author.id) {
                    await updateAuthors(this.author.id, data);
                } else {
                    await addAuthors(data);
                }

                await this.fetchUserAuthors();
                this.showModal = false;
            } catch (err) {
                this.error = err;
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" src="./AuthorPseudonymes.scss"></style>
